if (!customElements.get('notify-me')) {
  class NotifyMe extends HTMLElement {
    constructor() {
      super()
  
      this.form = this.querySelector('[data-notifyme-form]');
      this.formFeedbackMessage = this.form.querySelector('[data-message-global]');
      this.form.addEventListener('submit', this.submitForm.bind(this));
    }
  
    submitForm(event) {
  
      event.preventDefault()
  
      let email = this.querySelector('#emailBackInStock').value
  
      let platformFeed = this.dataset.klaviyoFeed
      let variantId = this.querySelector('[data-variant-id]').value;
      let variantDataId = platformFeed + variantId;
      
      this.klaviyoBackInStockSubscribe(email, variantDataId)
        .then((response) => {
          if (response.status == 'ok') {

            const openedModal = document.querySelector('modal-dialog.is-open');
            if (openedModal) {
              openedModal.querySelector('[data-notify-content]').classList.add('hidden')
              openedModal.querySelector('[data-notify-success]').classList.add('active')
              openedModal.querySelector('[data-notify-cancel]').classList.remove('hidden')
              openedModal.querySelector('[data-notify-submit]').classList.add('hidden')
            } else {
              console.error('No openned notifyme modal found');
            }

          } else {
            console.error(response);
            this.formFeedbackMessage.innerText = this.dataset.subscribeError
            // setTimeout(() => this.showError = false, 5000);
          }
        })
    }
  
    async klaviyoBackInStockSubscribe(email, variantDataId) {
      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoId}`;
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": email,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": variantDataId
              }
            }
          }
        }
      }
  
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: this.dataset.klaviyoApiRevision,
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
  
      const response = fetch(url, options)
        .then(async result => {
          if (result.ok == false) {
            const resultJson = await result.json();
            console.error(resultJson);
            return {
              status: 'error',
              error: response.ok
            }
          }
          
          return {
            status: 'ok'
          }
        })
        .catch(error => {
          console.error(error)
  
          return {
            status: 'error',
            error: response.ok
          }
        })
        
        return response
    }
  }
  customElements.define('notify-me', NotifyMe);
}
